import { render, staticRenderFns } from "./ServiceableAttributeTypeEditor.vue?vue&type=template&id=7c13d202&scoped=true"
import script from "./ServiceableAttributeTypeEditor.vue?vue&type=script&lang=js"
export * from "./ServiceableAttributeTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c13d202",
  null
  
)

export default component.exports